export const CAPSTONE_SUBMISSION_STATUS = {
  inReview: 'in_review',
  approved: 'approved',
  rejected: 'rejected',
};
